/* src/app/shared/components/image/image.component.scss */
.image-container {
  height: 32px;
  width: 32px;
  background-color: #c8c7cc;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  align-items: center;
  line-height: 32px;
  color: white;
}
img {
  object-fit: cover;
}
/*# sourceMappingURL=image.component.css.map */
